import React from 'react'
import { Link } from 'react-router-dom';
import styles from '../componentsStyles/Home.module.css';

const FirstComponent = () => {
  return (
    <div className={styles.firstComponent}>

        <div className={styles.imgContainer}>
            <img className={styles.img} src="./images/black-ice2.jpg" alt='black-flame' />
           
        </div>

        <div className={styles.text} style={{zIndex: '3'}}>
            <h3> 
                Welcome to MTS web solutions
            </h3>
            
            <div className={styles.smallTestimonial}>
                <p>
                I am here to help you impussionate your bussines, creating web solutions  that wil make your product shine on the market!
                </p>
                
                <p>
                Create a personalized web solution for your business, all my projects are made to have the best possible performance, delivering the best experience for your visitors.    
                </p>
                <Link to='/about'>More about me here!</Link> 
            </div>

            <div className={styles.action}>
                <button> <a href="#home-contact-form" className={styles.link}>Let's start building together</a> </button>
                <button
                title='See the documentations and guide'
                > <Link to='/docs' className={styles.link}> See the docs here</Link> </button>
            </div>

            <div>
                <h3> Scroll down to see more! </h3>
            </div>

        </div>


    </div>
  )
}

export default FirstComponent